import * as types from './mutation-types';
import { defaultOsObjectState } from './state';

export default {
  [types.RESET_OS_OBJECT](state) {
    Object.assign(state.osObject, defaultOsObjectState());
  },
  [types.SET_SUMMARY_OS_OBJECTS](state, payload) {
    state.summaryOsObjects = payload;
  },
  [types.SET_PAGINATION_OS_OBJECTS](state, payload) {
    state.paginationOsObjects = payload;
  },
  [types.SET_DETAILED_OS_OBJECT](state, payload) {
    state.osObject = payload;
  },
};
